if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // onSubmitHandler(evt) {
      //   evt.preventDefault();
      //   if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      //   this.handleErrorMessage();

      //   this.submitButton.setAttribute('aria-disabled', true);
      //   this.submitButton.classList.add('loading');
      //   this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      //   const config = fetchConfig('javascript');
      //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
      //   delete config.headers['Content-Type'];

      //   const formData = new FormData(this.form);
      //   if (this.cart) {
      //     formData.append(
      //       'sections',
      //       this.cart.getSectionsToRender().map((section) => section.id)
      //     );
      //     formData.append('sections_url', window.location.pathname);
      //     this.cart.setActiveElement(document.activeElement);
      //   }
      //   config.body = formData;

      //   fetch(`${routes.cart_add_url}`, config)
      //     .then((response) => response.json())
      //     .then((response) => {
      //       if (response.status) {
      //         publish(PUB_SUB_EVENTS.cartError, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           errors: response.errors || response.description,
      //           message: response.message,
      //         });
      //         this.handleErrorMessage(response.description);

      //         const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      //         if (!soldOutMessage) return;
      //         this.submitButton.setAttribute('aria-disabled', true);
      //         this.submitButton.querySelector('span').classList.add('hidden');
      //         soldOutMessage.classList.remove('hidden');
      //         this.error = true;
      //         return;
      //       } else if (!this.cart) {
      //         window.location = window.routes.cart_url;
      //         return;
      //       }

      //       if (!this.error)
      //         publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
      //       this.error = false;
      //       const quickAddModal = this.closest('quick-add-modal');
      //       if (quickAddModal) {
      //         document.body.addEventListener(
      //           'modalClosed',
      //           () => {
      //             setTimeout(() => {
      //               this.cart.renderContents(response);
      //             });
      //           },
      //           { once: true }
      //         );
      //         quickAddModal.hide(true);
      //       } else {
      //         this.cart.renderContents(response);
      //       }
      //     })
      //     .catch((e) => {
      //       console.error(e);
      //     })
      //     .finally(() => {
      //       this.submitButton.classList.remove('loading');
      //       if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      //       if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      //       this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      //     });
      // }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        let submitButton = this.submitButton;
        let overlaySpinner = this.querySelector('.loading-overlay__spinner');

        this.handleErrorMessage();
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        overlaySpinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const mainProductId = formData.get('id');
        const addedProductId = this.querySelector('input[name="product-id"]').value

        if (!mainProductId) {
          console.error("🚨 Missing product ID.");
          return;
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map(section => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // Step 1: Clear cart
        fetch("/cart/clear.js", { method: "POST" })
          .then(response => {
            if (!response.ok) throw new Error("Failed to clear cart.");
            return response.json();
          })
          .then(() => {
            console.log("✅ Cart cleared.");

            // Step 2: Add main product
            config.body = formData;
            return fetch(`${routes.cart_add_url}`, config);
          })
          .then(response => response.json())
          .then(response => {
            if (response.status) throw new Error("Failed to add main product:", response.status);
            console.log("✅ Main product added.");

            // Step 3: Check if user is eligible for a gift
            // console.log('addedProductId:', addedProductId);
            // if (shouldAddGift(addedProductId)) {
            //   console.log("🎁 User is eligible for a free gift!");

            //   let giftFormData = new FormData();
            //   giftFormData.append('id', GIFT_VARIANT_ID);
            //   giftFormData.append('quantity', 1);

            //   let giftConfig = fetchConfig('javascript');
            //   giftConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
            //   delete giftConfig.headers['Content-Type'];
            //   giftConfig.body = giftFormData;

            //   return fetch(`${routes.cart_add_url}`, giftConfig)
            //     .then(response => response.json())
            //     .then(response => {
            //       if (response.status) throw new Error("Failed to add gift product.");
            //       console.log("🎁 Gift product added.");
            //     });
            // } else {
            //   console.log("❌ User is NOT eligible for a free gift.");
            // }
          })
          .then(() => {
            // Step 4: Redirect to checkout
            window.location.href = "/checkout";
          })
          .catch(error => {
            console.error("❌ Error:", error);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            overlaySpinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
